function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "3745F11D-A0EA-46B4-9FF8-BFA2EB5AA2AF");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Kronos_Style-guide_3",
  transform: "translate(-436.000000, -344.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-22",
  transform: "translate(100.000000, 100.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-21",
  transform: "translate(0.000000, 144.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-14",
  transform: "translate(0.000000, 100.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-13",
  transform: "translate(120.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "24px_65",
  transform: "translate(216.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "0 0 24 0 24 24 0 24"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.6530833,16.0924625 L17.7089001,14.0952715 L21.4424147,12.1650281 C21.5613254,12.1032303 21.5613254,12.0039794 21.4417125,11.9438202 L17.2311506,9.81203184 L21.6579989,7.52317416 C21.8731149,7.41151685 22.0006864,7.21348315 21.999516,6.99321161 C21.9981115,6.77340824 21.8681993,6.57724719 21.6530833,6.46863296 L13.0194184,2.09784644 C12.8595444,2.01708801 12.6926481,2 12.5805256,2 C12.4775321,2 12.32351,2.01451311 12.1744035,2.08426966 L2.36005848,6.67907303 C2.13674983,6.78370787 2.00215604,6.97940075 2.00002438,7.20224719 C1.99794267,7.42532772 2.12925939,7.62359551 2.35092951,7.7326779 L7.06498918,10.0507959 L2.55878913,12.1603464 C2.43847399,12.2167603 2.43800584,12.3108614 2.55761875,12.3696161 L6.55891654,14.3373127 L2.36005848,16.3026685 C2.13651575,16.4073034 2.00192196,16.6029963 2.00002438,16.8258427 C1.99817674,17.0489232 2.12949347,17.247191 2.35092951,17.3558052 L11.6095777,21.909176 C11.7619613,21.9843165 11.9201968,22 12.0259992,22 C12.1374194,22 12.3036135,21.982912 12.4641898,21.900515 L21.658467,17.1467697 C21.873583,17.0351124 22.0011545,16.8370787 21.9999921,16.6168071 C21.9981115,16.3972378 21.8684333,16.2008427 21.6530833,16.0924625 Z M12.5557135,2.93843633 C12.5580543,2.93796816 12.5671833,2.93632959 12.5805256,2.93632959 C12.5948043,2.93632959 12.6053377,2.93820225 12.5997199,2.93492509 L20.6306386,7.00046816 L12.050109,11.4382022 C12.0477683,11.4386704 12.0388734,11.4405431 12.0259992,11.4405431 L12.0227221,11.4454588 L3.42159384,7.21582397 L12.5557135,2.93843633 Z M12.0512794,21.0613296 C12.0487046,21.0620318 12.0393415,21.0636704 12.0257651,21.0636704 L12.0229562,21.0690543 L3.42206199,16.8391854 L7.48913518,14.9351592 L11.6091096,16.9611423 C11.7617272,17.0362828 11.9199627,17.0522004 12.0257651,17.0522004 C12.1374194,17.0522004 12.3038476,17.0348783 12.4634875,16.9524813 L16.8252626,14.6975655 L20.6301705,16.6240637 L12.0512794,21.0613296 Z",
  id: "Shape",
  fill: "currentColor",
  fillRule: "nonzero"
}))))))));

var SvgLevels = function SvgLevels(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLevels, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/levels.e0cdf616.svg";
export { ForwardRef as ReactComponent };